import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { assign, map } from 'lodash';
import { service, request } from './service';
import * as tools from './tools';

var files = require.context('./modules', true, /\.api\.js$/);

var generators = files.keys().map(function (key) {
  return files(key).default;
});
export default assign.apply(void 0, [{}].concat(_toConsumableArray(map(generators, function (generator) {
  return generator({
    service: service,
    request: request,
    tools: tools
  });
}))));